import React from "react";
import TMSIframe from "../iframe-component/TMSIframe";

const Applications = () => {
  return <TMSIframe path="/applications" />;
};

export default React.memo(Applications);
